var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MediaVideoListInner.jinja');
require('./MediaVideoListInner.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MediaVideoList/MediaVideoListInner.js
// module id = 186
// module chunks = 0